<template>
  <div class="list-item">
    <div
      v-for="(item, index) in data"
      :key="index"
      class="item"
      @click="jumpDetail(item)"
    >
      <div class="content">
        <span v-if="data && data.length > 0" class="dot" />
        <span class="title">{{ item.title }} &nbsp; {{ item.subTitle }}</span>
      </div>
      <span v-if="isShowTime" class="date">{{ item.published_time }}</span>
    </div>
  </div>
</template>
  
<script>
export default {
  name: "UnionOverviewNewsListWithSubtitle",
  props: {
    isShowTime: {
      type: Boolean,
      default: true,
    },
    type: {
      type: Number,
      default: 1,
    },
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    /**
     * 跳转到详情页
     * @param {Object} item - 新闻项对象
     * info_type: 0-图文, 1-视频, 2-音频, 3-跳转, 4-文件, 5-附件
     */
    jumpDetail(item) {
      if (
        item.info_type === 0 ||
        item.info_type === 1 ||
        item.info_type === 2 ||
        item.info_type === 4
      ) {
        // 图文、视频、音频、文件类型，跳转到详情页
        this.$router.push({
          path: "/detail",
          query: {
            newsId: item.id,
          },
        });
      } else if (item.info_type === 3) {
        // 跳转类型，打开外部链接
        window.open(item.jump_url);
      } else if (item.info_type === 5) {
        // 附件类型，打开附件
        window.open(item.attachment);
      }
    },
  },
};
</script>
  
<style lang="scss" scoped>
.list-item {
  width: 98%;
  margin: 0 auto;
  height: auto;

  .item {
    height: 60px;
    font-size: 28px;
    font-family: Source Han Sans SC VF, Source Han Sans SC VF;
    font-weight: 500;
    color: #333333;
    line-height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    margin: 12px;

    &:hover {
      color: #b8190a;
      font-weight: 600;
    }

    .content {
      display: flex;
      align-items: center;
      overflow: hidden;
    }

    .dot {
      width: 8px;
      height: 8px;
      background-color: #c18c8d;
      border-radius: 50%;
      margin-right: 5px;
    }

    .title {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .date {
      font-size: 25px;
      font-family: Source Han Sans SC VF, Source Han Sans SC VF;
      font-weight: 400;
      color: #999999;
      white-space: nowrap;
    }
  }

  .item:last-child {
    border-bottom: 1px solid #e2e2e2;
  }
}
</style>


